/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderMasterZonesRoutingModule } from './builder-master-zones-routing.module';
import { MasterZoneDetailsComponent, MasterZoneListComponent } from './components';
import { MasterZoneDetailsBusinessService } from './resources/master-zone-details-business.service';
import { MasterZoneListBusinessService } from './resources/master-zone-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderMasterZonesRoutingModule,
  ],
  providers: [
    MasterZoneDetailsBusinessService,
    MasterZoneListBusinessService,
  ],
  declarations: [
    MasterZoneDetailsComponent,
    MasterZoneListComponent,
  ],
})

export class BuilderMasterZonesModule {
}
